// Derives the API origin and WebSocket URLs from VITE_API_URL.
// VITE_API_URL is either absolute with a trailing /api (prod, e.g.
// https://api.probsolver.in/api) or relative/unset (dev, Vite proxy).
// Strip only an anchored trailing /api — an unanchored replace('/api', '')
// matches the "//api." in the host of api.<domain> URLs.

export function getApiOrigin() {
    const raw = import.meta.env.VITE_API_URL || ''
    if (/^https?:\/\//i.test(raw)) {
        return raw.replace(/\/+$/, '').replace(/\/api$/, '')
    }
    return null
}

export function buildWsUrl(path, devPort = 5000) {
    const origin = getApiOrigin()
    if (origin) return origin.replace(/^http/i, 'ws') + path
    if (import.meta.env.PROD && typeof window !== 'undefined') {
        const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
        return `${proto}//${window.location.host}${path}`
    }
    return `ws://localhost:${devPort}${path}`
}

export function getApiDocsUrl() {
    return `${getApiOrigin() ?? 'http://localhost:5000'}/api-docs`
}
